"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emulateTouchFromMouseEvent = emulateTouchFromMouseEvent;
exports.dispatchMouseEvent = dispatchMouseEvent;
var isUndef_1 = __importDefault(require("licia/isUndef"));
var toBool_1 = __importDefault(require("licia/toBool"));
var isClick = false;
function emulateTouchFromMouseEvent(params) {
    var type = params.type, x = params.x, y = params.y, deltaX = params.deltaX, deltaY = params.deltaY;
    var el = document.elementFromPoint(x, y) || document.documentElement;
    switch (type) {
        case 'mousePressed':
            isClick = true;
            triggerTouchEvent('touchstart', el, x, y);
            break;
        case 'mouseMoved':
            isClick = false;
            triggerTouchEvent('touchmove', el, x, y);
            break;
        case 'mouseReleased':
            triggerTouchEvent('touchend', el, x, y);
            if (isClick) {
                triggerMouseEvent('click', el, x, y);
            }
            isClick = false;
            break;
        case 'mouseWheel':
            if (!(0, isUndef_1.default)(deltaX) && !(0, isUndef_1.default)(deltaY)) {
                triggerScroll(el, deltaX, deltaY);
            }
            break;
    }
}
function dispatchMouseEvent(params) {
    var type = params.type, x = params.x, y = params.y, deltaX = params.deltaX, deltaY = params.deltaY;
    var el = document.elementFromPoint(x, y) || document.documentElement;
    switch (type) {
        case 'mousePressed':
            isClick = true;
            triggerMouseEvent('mousedown', el, x, y);
            break;
        case 'mouseMoved':
            isClick = false;
            triggerMouseEvent('mousemove', el, x, y);
            break;
        case 'mouseReleased':
            triggerMouseEvent('mouseup', el, x, y);
            if (isClick) {
                triggerMouseEvent('click', el, x, y);
            }
            isClick = false;
            break;
        case 'mouseWheel':
            if (!(0, isUndef_1.default)(deltaX) && !(0, isUndef_1.default)(deltaY)) {
                triggerScroll(el, deltaX, deltaY);
            }
            break;
    }
}
function triggerMouseEvent(type, el, x, y) {
    el.dispatchEvent(new MouseEvent(type, {
        bubbles: true,
        cancelable: true,
        view: window,
        clientX: x,
        clientY: y,
    }));
}
function triggerTouchEvent(type, el, x, y) {
    var touch = new Touch({
        identifier: 0,
        target: el,
        clientX: x,
        clientY: y,
        force: 1,
    });
    el.dispatchEvent(new TouchEvent(type, {
        bubbles: true,
        touches: [touch],
        changedTouches: [touch],
        targetTouches: [touch],
    }));
}
function triggerScroll(el, deltaX, deltaY) {
    el = findScrollableEl(el, deltaX, deltaY);
    el.scrollLeft -= deltaX;
    el.scrollTop -= deltaY;
}
function findScrollableEl(el, deltaX, deltaY) {
    while (el) {
        if ((0, toBool_1.default)(deltaX) && isScrollable(el, 'x')) {
            return el;
        }
        if ((0, toBool_1.default)(deltaY) && isScrollable(el, 'y')) {
            return el;
        }
        el = el.parentElement;
    }
    return el || document.documentElement;
}
function isScrollable(el, direction) {
    var computedStyle = getComputedStyle(el);
    if (direction === 'x') {
        return (el.scrollWidth > el.clientWidth && computedStyle.overflowX !== 'hidden');
    }
    return (el.scrollHeight > el.clientHeight && computedStyle.overflowY !== 'hidden');
}
